<template>
  <nav class="navContainer">
    <ul ref="container">
      <li
        v-for="item in items"
        :key="item.id"
        @click="$emit('itemClick', item)"
        :class="{
          active: item._id === activeTicket,
          read: item.isRead === true,
        }"
      >
        <div class="ticket-item">
          <!-- Image -->
          <div class="image">
            <div
              v-if="item.isAnonymous && !item.closed"
              class="material-icons custom-icon-incognito"
            />
            <i
              v-if="!item.isAnonymous && !item.closed"
              class="material-icons user-icon"
            >
              account_circle
            </i>
            <i
              v-if="item.closed && !item.rating"
              class="material-icons user-icon closed-feedback"
            >
              check_circle
            </i>
            <i
              v-if="item.closed && item.rating"
              class="material-icons user-icon rated-feedback"
            >
              check_circle
            </i>
          </div>
          <!-- END - Image -->

          <div class="ticket-info-wrap">
            <!-- First Line -->
            <div class="first-line">
              <span class="last-message" v-if="item.closed && !item.rating">
                {{ getName(item.lastMessage.name) + labels.completedFeedback }}
              </span>
              <span class="last-message" v-else-if="item.closed && item.rating">
                {{ getName(item.lastMessage.name) + labels.ratedFeedback }}
              </span>
              <span class="last-message" v-else>
                {{ item.lastMessage.name + ': ' + item.lastMessage.message }}
              </span>
              <span class="updated-at">
                {{
                  item.lastMessage.createdAt === undefined
                    ? new Date()
                    : item.lastMessage.createdAt | moment('DD/MM/YYYY')
                }}
              </span>
            </div>
            <!-- END - First Line -->

            <!-- Last Line -->
            <div class="last-line">
              <span class="total-replies" v-if="item.totalReplies">
                ({{ item.totalReplies }}) {{ labels.list.answers }}
              </span>
              <span class="total-replies" v-if="!item.totalReplies">
                {{ labels.list.noAnswers }}
              </span>
              <!-- <div class="tags"> -->
              <small
                class="tag"
                :class="tag.type"
                v-for="tag in item.tags"
                :key="tag.type"
                >{{ tag.label }}</small
              >
              <!-- </div> -->
            </div>
            <!-- END - Last Line -->
          </div>
        </div>
      </li>
      <li
        class="last-item loading"
        v-observe-visibility="{
          callback: visibilityChanged,
          throttle: 300,
        }"
        v-if="hasMoreTickets"
      >
        <img src="icons/loading.svg" />
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  items: {
    type: Array,
    default: () => [],
  },
  activeTicket: {
    default: false,
  },
  hasMoreTickets: {
    default: false,
  },
}

export default {
  props,
  computed: {
    ...mapGetters(['resources']),
    labels() {
      return this.resources.page.home.feedbacks.tickets
    },
  },

  methods: {
    visibilityChanged(e) {
      this.$emit('loadMore', { isVisible: e })
    },
    getName(name) {
      return name ? `${name}: ` : ''
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~@/styles/custom/colors';
.navContainer {
  overflow: hidden;
  display: flex;
}

ul {
  flex-basis: 100%;
  padding: 0;
  width: 100%;
  overflow: auto;
  margin: 0;

  .last-item {
    list-style: none;
    text-align: center;

    img {
      width: 15%;
    }
  }

  li {
    background: map-get($theme-colors, 'light');
    border-bottom: 1px solid map-get($theme-colors, 'gray07');
    cursor: pointer;
    padding: 1rem;

    .ticket-item {
      align-items: center;
      display: flex;

      .image {
        margin-right: 15px;

        .custom-icon-incognito {
          background-position-x: 7px;
          background-position-y: 5px;
          border-radius: 24px;
          font-size: 24px;
          height: 45px;
          margin: 0 4px;
          width: 45px;
        }

        .user-icon {
          color: map-get($theme-colors, 'gray07');
          font-size: 53px;
        }

        .closed-feedback {
          color: map-get($theme-colors, 'orange');
        }

        .rated-feedback {
          color: map-get($theme-colors, 'green');
        }
      }

      .ticket-info-wrap {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        font-size: 14px;
        justify-content: center;

        .first-line {
          display: flex;

          .last-message {
            color: map-get($theme-colors, 'gray03');
            flex: 1;
            white-space: nowrap;
            overflow: hidden;
            padding-right: 10px;
            text-overflow: ellipsis;
            width: 80px;
          }

          .updated-at {
            color: map-get($theme-colors, 'gray04');
          }
        }

        .last-line {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-end;

          .total-replies {
            color: map-get($theme-colors, 'secondary');
            flex-grow: 1;
            font-weight: bold;
          }
        }
      }
    }

    &.read {
      background: white;

      .ticket-info-wrap .last-line .total-replies {
        font-weight: initial;
      }
    }

    &.active {
      background: map-get($theme-colors, 'beige');
      border-left: 5px solid map-get($theme-colors, 'secondary');
      padding-left: calc(1rem - 5px);

      .ticket-info-wrap .last-line .total-replies {
        font-weight: initial;
      }

      @media (max-width: 425px) {
        background: initial;
        border-left: initial;
      }
    }
  }
}
</style>
